export const YEAR_SEARCH_PARAM = 'year';

export const MONTH_SEARCH_PARAM = 'month';
